import { createStyles } from '@mantine/core';
import { motion } from 'framer-motion';
import React, { ReactNode } from 'react';

import { useIsSidebarOpen } from '@portals/redux';

type MainProps = {
  children: ReactNode;
  isHubsEnabled?: boolean;
};

export function Main({ children, isHubsEnabled }: MainProps) {
  const isSidebarOpen = useIsSidebarOpen();
  const { classes, cx } = useStyles(isSidebarOpen);

  return (
    <motion.div
      layout
      className={cx(classes.main, 'page-main', {
        'hubs-enabled': isHubsEnabled,
      })}
    >
      {children}
    </motion.div>
  );
}

const useStyles = createStyles((theme, isSidebarOpen: boolean) => ({
  main: {
    position: 'relative',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: theme.white,
    letterSpacing: '0.02em',

    display: 'grid',
    gridTemplateRows: `${theme.other.navbarHeight}px 1fr`,

    '&.hubs-enabled': {
      gridTemplateRows: 'unset',
      gridTemplateColumns: `${isSidebarOpen ? 300 : 76}px 1fr`,

      [theme.fn.smallerThan('xl')]: {
        gridTemplateColumns: `${isSidebarOpen ? 250 : 76}px 1fr`,
      },
    },
  },
}));
